import ApiService from '@/services/api.service';

const TestOrdersService = {
    getAllListing(parameters) {
        return ApiService.getWithArray('/PatientTestOrders/', parameters);
    },

    add(data) {
        return ApiService.post(`/PatientTestOrders`, data);
    },

    delete(id) {
        return ApiService.delete(`/PatientTestOrders/${id}`);
    },

    update(id, data) {
        return ApiService.put(`/PatientTestOrders/${id}`, data);
    },

    get(id) {
        return ApiService.get(`/PatientTestOrders/${id}`);
    }
};

export default TestOrdersService;
